<template>
  <div>
    <div>
      <MessagePublicChat @messagetoRespond="messagetoRespond" />
    </div>
    <div
      id="posts-container"
      :class="!display.show ? '' : 'bottom-none'"
      class="pb-1 mx-2 mt-2"
      v-if="!incomplete || configStreamer.data_rule === 'default'"
    >
      <Posts
        :room="room"
        :customer="customer"
        @setCustomer="setCustomer"
        :incomplete="incomplete"
        @showPost="showPost"
      />
    </div>
    <div class="d-flex align-center justify-space-between">
      <div>
        <div
          class="reply-head"
          v-if="show"
        >
          <div class="d-flex justify-space-between">
            <p class="my-0">
              <small>Respondiendo a {{ parent ? parent.author_name : '' }}</small>
            </p>
            <button @click="closeResponse">
              <Icon
                :width="15"
                :color="'rgba(0,0,0,.54)'"
                :icon="'close'"
              />
            </button>
          </div>
          <p class="reply-message">- {{ parent ? parent.message : '' }}</p>
        </div>
        <TextFieldPublicChat
          @sendMessage="sendMessage"
          :disabled="false"
          v-if="!incomplete"
        />
        <div v-else-if="configStreamer.data_rule === 'default' && !customer">
          <button
            class="send-message"
            @click="setCustomer"
          >
            ENVIAR MENSAJE
          </button>
        </div>
      </div>
      <div class="pa-2 d-flex pl-0">
        <v-btn
          fab
          small
          bottom
          left
          elevation="0"
          color="transparent"
          @click="toggleMute"
          v-if="isIos"
        >
          <Icon
            :width="24"
            :color="video.audio ? 'white' : '#999'"
            :icon="video.audio ? 'volume-high' : 'volume-off'"
          />
        </v-btn>
        <!-- <v-badge
            bordered
            bottom
            color="primary"
            dot
            offset-x="17"
            offset-y="12"
            class="chat-btn-badge"
            :class="chat.unreadMessages ? 'active-badge' : ''"
          >
            <v-btn
              fab
              small
              bottom
              left
              elevation="0"
              color="transparent"
              @click="showChat"
            >
              <Icon
                :width="24"
                :color="'#fff'"
                :icon="'android-messages'"
              />
            </v-btn>
          </v-badge> -->
        <div v-if="isSecureContext">
          <CopyText
            ref="copy-text"
            title="Copia el link y envíalo a otras personas para que se unan a la transmisión"
            action="Copiar"
            :text="`${parentLocation.hostname}${parentLocation.pathname}?ocularStreaming=${$route.params.roomId}`"
          />
          <v-btn
            fab
            small
            bottom
            left
            elevation="0"
            color="transparent"
            @click="$refs['copy-text'].toggle()"
          >
            <Icon
              :width="24"
              :color="'#fff'"
              :icon="'share-variant'"
            />
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    CopyText: () => import(/* webpackPrefetch: true */ '@/components/CopyText.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    TextFieldPublicChat: () => import(/* webpackPrefetch: true */ '@/views/room/components/public-chat/TextField.vue'),
    MessagePublicChat: () => import(/* webpackPrefetch: true */ '@/views/room/components/public-chat/Messages.vue'),
    Posts: () => import(/* webpackPrefetch: true */ '@/views/room/components/post/Index.vue')
  },
  computed: {
    chat() {
      return this.$store.state.rooms.item.chat
    },
    parentLocation() {
      return this.$store.state.parentLocation
    },
    isSecureContext() {
      return window.isSecureContext
    }
  },
  props: {
    video: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    isIos: {
      type: Boolean,
      default: true
    },
    display: {
      type: Object,
      default: null
    },
    room: {
      type: Object,
      default: null
    },
    incomplete: {
      type: Boolean,
      default: false
    },
    configStreamer:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false,
      parent: null
    }
  }
})
export default class Options extends Vue {
  toggleMute() {
    if (this.customer || this.room.data_rule === 'default'){
      this.$emit('toggleMute')
    }
  }

  setCustomer() {
    this.$emit('setCustomer')
  }

  showPost(selectedPost) {
    this.$emit('showPost', selectedPost)
  }

  sendMessage(message) {
    if (!this.customer) {
      return false
    }

    const data = {
      author: this.customer,
      session: this.room._id,
      message,
      level: 1,
      uuid: this.$store.state.widget.uuid
    }

    if (this.parent) {
      data.parent = this.parent
    }

    this.closeResponse()
  }

  messagetoRespond(parentMessage) {
    try {
      document.getElementById('messageInput').focus()

      this.parent = {
        message_id: parentMessage._id,
        author_name: parentMessage.author.name,
        message: parentMessage.message
      }

      this.show = true
    } catch (error) {
      console.log('messagetoRespond ERROR', error);
    }
  }

  closeResponse() {
    this.show = false
    this.parent = null
  }

}
</script>
<style>
.reply-head {
  width: 100%;
  background: #fff;
  padding: 10px 20px 5px;
  color: rgb(129, 129, 129);
  border-top: 1px solid rgb(238, 238, 238);
  border-bottom: 1px solid rgb(238, 238, 238);
  position: absolute;
  bottom: 50px;
}

.send-message {
  margin: 0 15px;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  width: 240px;
  height: 35px;
  color: #434343;
  font-size: 14px;
  font-weight: 600;
}
</style>
